import * as React from 'react'
import * as moment from 'moment'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Button } from '@mv-submodules/inplant-components-fe'
import { ChronoTask } from '../../../../types/chronoTasks'
import { FormData } from '../../../../types/pageForm'

interface OwnProps {
  sourceTask: ChronoTask
  notes?: string
  createAnomaly: (data: FormData) => Promise<any>
}

export type Props = OwnProps & WithTranslation
export const ANOMALY_DUE_DAYS = 7

export const anomalyDetailUrl = (id: string) => `/anomalie/anomalie-ongoing/${id}`

export const buildAnomalyPayload = (source: ChronoTask, description: string, today: string): FormData => ({
  activity: source.activity,
  description,
  target: source.target,
  destination: source.destination,
  inChargeUser: source.inChargeUser && source.inChargeUser.id,
  rolesWithVisibility: source.rolesWithVisibility,
  rolesWithAction: source.rolesWithAction,
  effectiveFromDate: today,
  dueAtDate: moment(today).add(ANOMALY_DUE_DAYS, 'days').format('YYYY-MM-DD'),
  customProperties: source.customProperties,
  // the anomaly starts with no validation requirement, hence `rolesWithValidation` is not sent
  mustBeValidated: false,
  automaticRenewal: false,
  noticeMessage: false,
})

const CreateAnomalyButton = (props: Props) => {
  const { t, notes, sourceTask, createAnomaly } = props
  const [isCreating, setIsCreating] = React.useState(false)
  const [createdId, setCreatedId] = React.useState<string | undefined>(undefined)
  const [error, setError] = React.useState<string | undefined>(undefined)

  const handleClick = async () => {
    setIsCreating(true)
    setError(undefined)
    try {
      const payload = buildAnomalyPayload(sourceTask, (notes || '').trim(), moment().format('YYYY-MM-DD'))
      const result = await createAnomaly(payload)
      const { id } = result[0]
      setIsCreating(false)
      setCreatedId(id)
    } catch {
      setIsCreating(false)
      setError(t('chronoframe.dueDates.detail.createAnomalyError'))
    }
  }

  return (
    <div className="mt-4 pt-3 border-top">
      {createdId ? (
        <div className="alert alert-success" role="alert">
          {t('chronoframe.dueDates.detail.anomalyCreated')}{'. '}
          <a href={anomalyDetailUrl(createdId)} target="_blank" rel="noopener noreferrer">
            {t('chronoframe.dueDates.detail.openAnomaly')}
          </a>
        </div>
      ) : (
        <React.Fragment>
          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
          <p className="mb-2">{t('chronoframe.dueDates.detail.createAnomalyIntro')}</p>
          <Button
            variant="secondary"
            spacing={{ horizontal: false }}
            onClick={handleClick}
            label={t('chronoframe.dueDates.detail.createAnomaly')}
            isLoading={isCreating}
          />
        </React.Fragment>
      )}
    </div>
  )
}

export default withTranslation()(CreateAnomalyButton)
